import React, { FunctionComponent } from 'react';
import { useTheme } from '@rbx/ui';

type TNoNewNotificationsProps = {
  size?: number;
  enableNotificationsM2?: boolean;
};

const NoNewNotifications: FunctionComponent<TNoNewNotificationsProps> = ({
  size,
  enableNotificationsM2,
}) => {
  const theme = useTheme();

  if (enableNotificationsM2) {
    return (
      <svg
        width='121'
        height='121'
        viewBox='0 0 121 121'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M92.0911 1.1032L3.2259 24.9146C1.6255 25.3434 0.675757 26.9884 1.10458 28.5888L24.9159 117.454C25.3448 119.054 26.9898 120.004 28.5902 119.575L117.455 95.7639C119.056 95.3351 120.005 93.6901 119.577 92.0897L95.7653 3.22452C95.3365 1.62412 93.6915 0.674375 92.0911 1.1032Z'
          stroke={theme.palette.components.divider}
          strokeOpacity='1'
          strokeWidth='2'
        />
        <path
          d='M71.7557 45.5874C73.8177 43.5252 77.3407 44.5027 78.0457 47.3325L87.1957 84.0964C87.6637 85.9744 86.0067 87.6964 84.1117 87.3004L46.1737 79.3764C43.2557 78.7674 42.1817 75.1614 44.2887 73.0544L71.7557 45.5874ZM72.1497 81.7364L84.1407 84.2414L81.2517 72.6354L72.1497 81.7364ZM58.1897 78.8204L68.6407 81.0034L80.4057 69.2378L77.8887 59.1226L58.1897 78.8204ZM75.1357 48.0571C74.9947 47.4912 74.2887 47.2961 73.8767 47.7085L46.4097 75.1754C45.9887 75.5964 46.2047 76.3184 46.7877 76.4404L54.7427 78.1014C54.8077 77.9884 54.8877 77.8814 54.9837 77.7854L77.0437 55.7251L75.1357 48.0571Z'
          fill={theme.palette.content.standard}
        />
        <path
          d='M26.4535 72.1214C31.3395 61.6564 41.1115 60.5319 47.0685 60.9829C47.8945 61.0455 48.5135 61.7655 48.4515 62.5913C48.3895 63.4172 47.6695 64.0364 46.8435 63.9741C41.3605 63.5589 33.2655 64.6238 29.1725 73.3914C28.8215 74.1414 27.9285 74.4654 27.1785 74.1144C26.4275 73.7644 26.1035 72.8724 26.4535 72.1214Z'
          fill={theme.palette.content.standard}
        />
        <path
          d='M31.0469 50.9712C32.1509 50.9712 33.0469 51.8668 33.0469 52.9712C33.0469 54.0758 32.1509 54.9712 31.0469 54.9712C29.9419 54.9712 29.0469 54.0758 29.0469 52.9712C29.0469 51.8668 29.9419 50.9712 31.0469 50.9712Z'
          fill={theme.palette.content.standard}
        />
        <path
          d='M42.0519 46.2212C44.2639 46.2212 46.0579 48.0148 46.0579 50.2271C46.0579 52.4393 44.2639 54.2329 42.0519 54.2329C39.8399 54.2328 38.0469 52.4392 38.0469 50.2271C38.0469 48.0149 39.8399 46.2213 42.0519 46.2212Z'
          fill={theme.palette.content.standard}
        />
        <path
          d='M54.6738 29.8218C55.0058 29.0632 55.8898 28.7176 56.6478 29.0493C57.4068 29.3815 57.7528 30.2661 57.4208 31.0249C53.8728 39.136 57.2078 46.9044 59.2838 49.7105C59.7768 50.3764 59.6358 51.3155 58.9698 51.8081C58.3038 52.3006 57.3647 52.1604 56.8717 51.4946C54.3987 48.1521 50.5538 39.2404 54.6738 29.8218Z'
          fill={theme.palette.content.standard}
        />
        <path
          d='M72.6631 28.3198C73.4481 28.0552 74.3001 28.4766 74.5651 29.2612C74.8291 30.0462 74.4071 30.8978 73.6221 31.1626C70.1381 32.3376 68.0011 35.206 66.9011 38.1548C66.3541 39.6218 66.0881 41.0519 66.0391 42.1958C66.0151 42.7679 66.0461 43.2391 66.1081 43.5894C66.1761 43.9655 66.2591 44.0875 66.2471 44.0718C66.7441 44.7343 66.6091 45.6743 65.9471 46.1714C65.2851 46.6681 64.3451 46.5339 63.8481 45.8716C63.4591 45.3537 63.2621 44.708 63.1561 44.1196C63.0461 43.5025 63.0111 42.8033 63.0421 42.0679C63.1051 40.5955 63.4391 38.8546 64.0911 37.106C65.3901 33.6224 68.0521 29.8752 72.6631 28.3198Z'
          fill={theme.palette.content.standard}
        />
        <path
          d='M27.4829 40.5728C29.1049 40.573 30.4199 41.8875 30.4199 43.5093C30.4199 45.131 29.1049 46.4456 27.4829 46.4458C25.8619 46.4458 24.5469 45.1311 24.5469 43.5093C24.5469 41.8874 25.8619 40.5728 27.4829 40.5728Z'
          fill={theme.palette.content.standard}
        />
        <path
          d='M37.7586 34.1626C37.9196 33.5625 38.5365 33.206 39.1365 33.3667L44.0395 34.6802C44.6395 34.841 44.9965 35.458 44.8355 36.0581L43.5216 40.9614C43.3606 41.5615 42.7435 41.9181 42.1435 41.7573L37.2405 40.4429C36.6405 40.2821 36.2845 39.6651 36.4445 39.065L37.7586 34.1626Z'
          fill={theme.palette.content.standard}
        />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.2034 86.9165L48.3634 73.9965C53.8834 72.0365 55.4834 64.9565 51.3234 60.7965L33.2034 42.6765C29.0434 38.5165 22.0034 40.1165 20.0034 45.6365L7.08344 81.7965C5.96344 84.9965 9.00344 88.0365 12.2034 86.9165Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M56.4834 49.7565L76.7234 29.5165C78.6834 27.5565 81.8434 27.5565 83.8034 29.5165L84.0434 29.7565C85.2034 30.9165 87.1234 30.9165 88.2834 29.7565C89.4434 28.5965 89.4434 26.6765 88.2834 25.5165L88.0434 25.2765C83.7634 20.9965 76.7634 20.9965 72.4834 25.2765L52.2434 45.5165C51.0834 46.6765 51.0834 48.5965 52.2434 49.7565C53.4034 50.9165 55.3234 50.9165 56.4834 49.7565Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M36.4834 29.2765L36.2434 29.5165C35.0834 30.6765 35.0834 32.5965 36.2434 33.7565C37.4034 34.9165 39.3234 34.9165 40.4834 33.7565L40.7234 33.5165C45.0034 29.2365 45.0034 22.2365 40.7234 17.9565L40.5234 17.7565C39.3234 16.5565 37.4034 16.5565 36.2434 17.7565C35.0834 18.9165 35.0834 20.8365 36.2434 21.9965L36.4834 22.2365C38.4034 24.1565 38.4034 27.3565 36.4834 29.2765Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M64.4834 49.2765L60.2434 53.5165C59.0834 54.6765 59.0834 56.5965 60.2434 57.7565C61.4034 58.9165 63.3234 58.9165 64.4834 57.7565L68.7234 53.5165C70.6834 51.5565 73.8434 51.5565 75.8034 53.5165L80.1234 57.8365C81.2834 58.9965 83.2034 58.9965 84.3634 57.8365C85.5234 56.6765 85.5234 54.7565 84.3634 53.5965L80.0434 49.2765C75.7234 44.9965 68.7634 44.9965 64.4834 49.2765Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M56.4834 25.2765L44.2434 37.5165C43.0834 38.6765 43.0834 40.5965 44.2434 41.7565C45.4034 42.9165 47.3234 42.9165 48.4834 41.7565L60.7234 29.5165C65.0034 25.2365 65.0034 18.2365 60.7234 13.9565L56.4834 9.7165C55.3234 8.5565 53.4034 8.5565 52.2434 9.7165C51.0834 10.8765 51.0834 12.7965 52.2434 13.9565L56.4834 18.1965C58.4034 20.1565 58.4034 23.3565 56.4834 25.2765Z'
        fill={theme.palette.content.muted}
      />
    </svg>
  );
};

export default NoNewNotifications;
